import React from 'react';
import Header from './Header';
import Container from '@mui/material/Container';
// import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
// import Button from '@mui/material/Button';
// import Paper from '@mui/material/Paper';
// import Grid from '@mui/material/Grid';
import './style/Design.css';

/**
 *
 * @return {object}
 */
export default function Design() {
  return (
    <div>
      <Header></Header>
      <Container container spacing={2} sx={{width: 2/3}} className='background'>
        <h4 className='title'>Design</h4>
        <h5 className='subtitle'>a selection of games and other things I’ve
          worked on (<a className="link" href="https://anikam.itch.io/" target="_blank"
          rel="noopener noreferrer">here's more</a>)</h5>
        <ImageList cols={2} gap={2}
          style={{'padding-top': '1vh'}}>
          {itemData.map((item) => (
            <a className="link" href={item.link}
              target="_blank" rel="noopener noreferrer">
              <ImageListItem key={item.img} style={{'width': '90%'}}>
                <img
                  srcSet={`${item.img}`}
                  src={`${item.img}`}
                  alt={item.title}
                  value={item.value}
                  loading="lazy"
                  style={{'cursor': 'pointer'}}
                />
                <ImageListItemBar
                  title={<span className='title'>{item.title}</span>}
                  subtitle={<span className='des'>{item.des}</span>}
                  position="below"
                  style={{'padding-top': '1vh'}}
                />
              </ImageListItem>
            </a>
          ))}
        </ImageList>
      </Container>
    </div>
  );
}

const itemData = [
  {
    img: './assets/design/parcy.png',
    title: 'Parcy\'s Parcels',
    des: 'A set of mini-games about a mailmouse and his day',
    value: 0,
    link: 'https://anikam.itch.io/parcys-parcels',
  },
  {
    img: './assets/design/fireflies.gif',
    title: 'Fireflies',
    des: ' An interactive poster for the Last of Us',
    value: 1,
    link: 'https://anikam.itch.io/fireflies',
  },
  {
    img: './assets/design/bubble.gif',
    title: 'Bubble Pop',
    des: 'A one-button arcade style game',
    value: 2,
    link: 'https://anikam.itch.io/bubblepop',
  },
  {
    img: './assets/design/battle.png',
    title: 'Water Balloon Battle',
    des: 'Rules and pieces for analog Mario Kart Balloon Battle',
    value: 2,
    link: './assets/design/waterBalloonBattle.pdf',
  },
];
